import { Api_routes, server_url } from '@/config/API_Routes';
import { deleteRequest, getRequest, patchRequest, postRequest } from '@/config/axios-config';

const createInboundApplicationForm = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createInboundApplicationForm,
        body
      );
      resolve(response);
    } catch (err) {
      reject(err);
    }
  });
};

const getAllInboundApplicationForms = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllInboundApplicationForms
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteInboundApplicationForm = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.deleteInboundApplicationForm +
          '/' +
          id
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const updateInboundApplicationForm = (body, id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.updateInboundApplicationForm +
          '/' +
          id,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const getInboundFormsConversionRates = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getConversionRatesForForms,
        body
      );
      resolve(response);
    } catch (err) {
      reject(err);
    }
  });
};

export {
  createInboundApplicationForm,
  getAllInboundApplicationForms,
  deleteInboundApplicationForm,
  updateInboundApplicationForm,
  getInboundFormsConversionRates,
};
